/* Teeinblue: Custom Mobile Sticky Gallery for YOUNI.ONE */
document.addEventListener("DOMContentLoaded", () => {
  
  const fixedLivePreview = () => {
    let galleryWrapperSelector = ".main-product__media"; 
    let $gallery = document.querySelector(galleryWrapperSelector);
    if (!$gallery) {
      galleryWrapperSelector = ".product__slides";
      $gallery = document.querySelector(galleryWrapperSelector);
    }
    if (!$gallery) {
      galleryWrapperSelector = "swiper-product-gallery";
      $gallery = document.querySelector(galleryWrapperSelector);
    }

    // 智能找尋畫廊容器
    if (!$gallery) {
      const $teeGalleryID = document.querySelector("#tee-gallery");
      if ($teeGalleryID && $teeGalleryID.parentElement) {
        $gallery = $teeGalleryID.parentElement;
        $gallery.classList.add("youni-mobile-gallery-wrapper");
        galleryWrapperSelector = ".youni-mobile-gallery-wrapper";
      } else {
        return; // 搵唔到就安全退出，唔會報錯
      }
    }

    const style = document.createElement("style");
    style.innerHTML = `
      /* === 強制打破任何 CSS 結界 === */
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery-content {
        background: #fff !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .1) !important;
        display: flex !important;
        justify-content: center !important;
        left: 0 !important;
        position: fixed !important;
        top: 0 !important;
        width: 100vw !important;
        margin: 0 !important;
        padding: 0 !important;
        z-index: 9999 !important; /* 推高層級防遮擋 */
        transition: opacity 0.3s ease, visibility 0.3s ease;
      }
      
      /* 隱藏 Loading Spinner */
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-spinner,
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .t-spinner,
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} svg[class*="spinner"],
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} [class*="loader"] {
        display: none !important;
      }
      
      /* 彈出視窗時隱藏 */
      body.vm--block-scroll.gallery--sticky ${galleryWrapperSelector} .tee-gallery-content,
      body.tee-modal-open.gallery--sticky ${galleryWrapperSelector} .tee-gallery-content {
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }
      body.vm--block-scroll .gallery--close-button,
      body.tee-modal-open .gallery--close-button {
        display: none !important;
      }
      
      /* 圖片原比例 */
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery {
        width: 100% !important;
        max-width: 100vw !important;
      }
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery > img,
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery canvas,
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-preview-image {
        width: 100% !important;
        height: auto !important;
        max-height: 50vh !important; /* 加返個安全高度，防張圖過長 */
        object-fit: contain !important;
      }

      /* 隱藏縮圖 */
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-thumbnails,
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-slider__dots {
        display: none !important;
      }
      
      /* X 關閉掣鎖定 */
      .gallery--close-button {
        background-image: url('data:image/svg+xml;utf8,<svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 16px 16px;
      }

      .gallery--sticky:not(.gallery--sticky--hide) .gallery--close-button {
        display: block !important;
        position: fixed !important; 
        top: 20px !important;
        right: 20px !important;
        z-index: 10000 !important;
        opacity: 0.6;
        width: 16px;
        height: 16px;
      }
      
      /* === 修復：重開 Gallery 按鈕的外觀與定位 === */
      .sticky-gallery-button {
        display: none; /* 預設隱藏 */
        position: fixed !important;
        bottom: 24px !important;
        right: 24px !important;
        width: 48px !important;
        height: 48px !important;
        background-color: #000 !important; /* 黑色底色，配合 YOUNI 高級感 */
        border-radius: 50% !important;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
        z-index: 99999 !important; /* 確保喺最面層 */
        cursor: pointer;
        /* 加入優雅的相片 Icon */
        background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.5 13.5L11 16.51L14.5 12L19 18H5L8.5 13.5Z" fill="white"/></svg>');
        background-size: 24px 24px;
        background-position: center;
        background-repeat: no-repeat;
        transition: transform 0.2s ease, opacity 0.2s ease;
      }
      
      .sticky-gallery-button:active {
        transform: scale(0.95) !important; /* 撳落去有微縮放效果 */
      }

      /* 當 Gallery 被隱藏時，顯示這個重開按鈕 */
      .gallery--sticky.gallery--sticky--hide .sticky-gallery-button {
        display: block !important;
      }
    `;
    document.head.appendChild(style);

    let hasStickyButton = false;
    let hasCloseButton = false;

    const onScroll = () => {
      const $teeGallery = document.querySelector("#tee-gallery") || document.querySelector(".tee-gallery-content"); 
      const $tForm = document.getElementById("tee-artwork-form") || document.querySelector(".tee-form-wrapper") || document.querySelector("[data-product-grid-content]");
      
      if (!$teeGallery || !$tForm || !$gallery) return; 

      // 產生重開按鈕
      if (!hasStickyButton) {
        const stickyButton = document.createElement("div");
        stickyButton.className = "sticky-gallery-button";
        stickyButton.addEventListener("click", (e) => {
          e.stopPropagation();
          e.preventDefault();
          document.body.classList.remove("gallery--sticky--hide");
        });
        document.body.appendChild(stickyButton);
        hasStickyButton = true;
      }
      
      // 產生關閉按鈕
      if (!hasCloseButton) {
        const closeButton = document.createElement("div");
        closeButton.className = "gallery--close-button";
        closeButton.addEventListener("click", (e) => {
          e.stopPropagation();
          e.preventDefault();
          document.body.classList.add("gallery--sticky--hide");
        });
        $teeGallery.appendChild(closeButton);
        hasCloseButton = true;
      }

      const galleryTop = $gallery.getBoundingClientRect().top;
      const tFormBottom = $tForm.getBoundingClientRect().bottom;
      const galleryContentHeight = $teeGallery.offsetHeight || 300; 

      if (galleryTop < -10 && tFormBottom > galleryContentHeight) {
        document.body.classList.add("gallery--sticky");
        $gallery.style.height = `${galleryContentHeight}px`;
      } else {
        document.body.classList.remove("gallery--sticky");
        $gallery.style.removeProperty("height");
      }
    };

    const $window = window;
    $window.addEventListener("scroll", onScroll);
    $window.addEventListener("DOMMouseScroll", onScroll); 
  };

  const w = window.innerWidth;
  const h = window.innerHeight;
  if (h / w > 1.5 && w < 768) {
    let attempts = 0;
    const checkExist = setInterval(function () {
      if (document.querySelector(".main-product__media") || document.querySelector(".product__slides") || document.querySelector("#tee-gallery")) {
        clearInterval(checkExist);
        fixedLivePreview();
      }
      attempts++;
      if (attempts > 20) clearInterval(checkExist); 
    }, 500);
  }
});